import React from 'react';
import PropTypes from 'prop-types';
import { WestpacPayment } from '@PetSureAustralia/petsure-react-payment-components';
import { FormatAsCurrencyForLocale } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import httpClient from 'axios';
import './enterCreditCardDetails.scss';
import { OutstandingPaymentPropTypes } from '../../../propTypes/outstandingPayment';
import { PreloadWrapper } from '../../preloadWrapper/preloadWrapper';
import { ACTION_TYPE, PAYMENT_METHOD } from '../../../constants/constants';
import { useEnterCreditCardDetails } from './useEnterCreditCardDetails';

export const EnterCreditCardDetails = ({ instalmentToPay, onCancelButton }) => {
  const {
    initWebColError,
    takePaymentError,
    isLoading,
    paymentDetails,
    handleBeforeSubmit,
    handleSubmitSuccess,
    handleSubmitFail,
    partner,
    broker
  } = useEnterCreditCardDetails(instalmentToPay);

  return (
    <div className="petSureForm verticalStacked">
      <div className="iframe-container">
        <div className="total-amount-details">
          <strong>Total: </strong>
          <span className="total-amount">{FormatAsCurrencyForLocale(paymentDetails.amount)}</span>
        </div>
        <PreloadWrapper isLoading={isLoading}>
          <WestpacPayment
            config={{
              partner,
              broker,
              actionType: ACTION_TYPE.PAYNOW,
              defaultPaymentType: PAYMENT_METHOD.CREDIT_CARD,
              useMockData: false,
              environment: process.env.REACT_APP_ENV,
              actionButtonsBar: {
                primary: {
                  actionItems: [
                    {
                      id: 'cancelButton',
                      buttonStyle: 'primary outline',
                      buttonLabel: 'Cancel',
                      showSpinner: true
                    },
                    {
                      id: 'submitButton',
                      buttonStyle: 'primary',
                      buttonLabel: 'Submit',
                      showSpinner: true
                    }
                  ],
                  containerType: 'rows'
                }
              }
            }}
            httpClient={httpClient}
            onBackToSummary={onCancelButton}
            onBeforeSubmit={handleBeforeSubmit}
            onSubmitFail={handleSubmitFail}
            onSubmitSuccess={handleSubmitSuccess}
            paymentDetails={paymentDetails}
          />
        </PreloadWrapper>
        {initWebColError && <span>{initWebColError}</span>}
        {takePaymentError && <span>{takePaymentError}</span>}
      </div>
    </div>
  );
};

EnterCreditCardDetails.propTypes = {
  instalmentToPay: OutstandingPaymentPropTypes,
  onCancelButton: PropTypes.func
};
